import React from 'react'
import PropTypes from 'prop-types'
import createReactClass from 'create-react-class'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle, faCirclePlus } from '@fortawesome/free-solid-svg-icons'

import { withGettext } from 'lib/gettext'
import { SchemaBranchMixin } from 'legacy/libs/baobab-react-mixins'
import { FormComponentMixin } from 'legacy/libs/react-form-tools'
import BaobabPropTypes from 'legacy/libs/baobab-prop-types'
import TagMixin from './mixins/tag'

const AddTagButton = createReactClass({
  mixins: [SchemaBranchMixin, FormComponentMixin, TagMixin],

  propTypes: {
    gettext: PropTypes.func.isRequired,
    tree: PropTypes.oneOfType([BaobabPropTypes.baobab, BaobabPropTypes.cursor]),
  },

  schema: {
    pk: null,
  },

  cursors(props) {
    return {
      selectedTags: props.selectedTags,
    }
  },

  onAddClick() {
    this.selectTagsTree(this.props.tree)
  },

  render() {
    const { gettext } = this.props

    return this.isSelected(this.state.pk) ? (
      <span className="mr-3 inline-block text-xs text-black/25">
        <FontAwesomeIcon
          icon={faCheckCircle}
          className="mr-1"
          aria-hidden="true"
        />
        {gettext('Added')}
      </span>
    ) : (
      <button
        className="inline-block text-xs text-success"
        onClick={this.onAddClick}
      >
        <FontAwesomeIcon
          icon={faCirclePlus}
          className="mr-1"
          aria-hidden="true"
        />
        {gettext('Add')}
      </button>
    )
  },
})

export default withGettext(AddTagButton)
